import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericIdbaService } from '../generic-idba-service.service';
import { GenericIdbaRequestModel } from '../../models/generic-idba-request-model';
import { CadastroGenerico } from '../../models/generics/cadastro-generico';

@Injectable({
  providedIn: 'root'
})
export class CadastroGenericoService extends GenericIdbaService {

  declare model: CadastroGenerico;

  constructor(http: HttpClient) { 
    super(http, new CadastroGenerico());
    this.programName = "cad/genericos/cadgenerico.p";
  }

  pesquisarPorModuloAssunto(modulo: string, assunto: string)
  {
    var request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar-modulo-assunto";
    request.parameters = { modulo, assunto };
    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, { observe: "response" });
  }
}
